// say(): fill a fixed line (shared/content LINES, the app's own copy) for display. Tokens: {n} buddy name, {Task} the
// task's short name (taskShort of a card title or the user's thing), {k}, {time}, {title}, {year}. {Task} is
// capitalized at the start of a sentence (or after a colon) and a leading article is lowercased mid-sentence; with no
// task it reads "it". Any token left over is dropped, so a line that gains a token later never shows "{Task}" on screen.
// Every LINES text the app shows goes through here.
import { fill } from '@shared/content/lines';
import { taskShort } from '@shared/rules';

export interface SayVars { n?: string; task?: string | null; k?: number | string; time?: string; title?: string; year?: string }

const upFirst = (x: string) => x.charAt(0).toUpperCase() + x.slice(1);

export function say(text: string, v: SayVars = {}): string {
  const task = v.task ? taskShort(v.task) : '';
  const out = text.replace(/\{Task\}/g, (_m, at: number) => {
    const before = text.slice(0, at).trimEnd();
    const start = before === '' || /[.!?…:]["”')]?$/.test(before);
    if (!task) return start ? 'It' : 'it';
    if (start) return upFirst(task);
    return task.replace(/^(The|A|An|My|Your)\b/, (w) => w.toLowerCase());
  });
  const vars: Record<string, string | number> = {};
  for (const [k, x] of Object.entries(v)) if (k !== 'task' && x != null) vars[k] = x as string | number;
  return fill(out, vars).replace(/\s*\{\w+\}/g, '');
}
